import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useMutation, useQueryClient } from 'react-query';
import { foldersKeys } from './foldersKeys';
import { FoldersV2 } from './getFoldersV2';

export const updateFolder = async (folder: Partial<FoldersV2>) => {
  const response = await EXPRESS_API.put(`/folders/${folder.folderId}`, folder);
  return response.data;
};

export const useUpdateFolderMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation((folder: Partial<FoldersV2>) => updateFolder(folder), {
    onError: () => {
      errorToast({
        title: 'An error occurred updating folder, please try again later!',
      });
    },
    onSuccess: async () => {
      successToast({
        title: `You have successfully updated the folder`,
      });
      await queryClient.invalidateQueries(foldersKeys.all());
      onSuccess && onSuccess();
    },
  });
};
